import { Container, Grid } from "@material-ui/core";
import React from "react";
import { CourseForSignupViewModel } from "../../../../model/ExamSignup/ExamSessionForSignupViewModel";
import { ModuleSelectionViewModel } from "../../../../model/ExamSignup/ModuleSelectionViewModel";
import { useSignUpContext } from "../../CertificationDataWizardContext/CertificationDataWizardContext";
import { ControlButtons } from "../shared/ControlButtons";
import ModuleSelector from "./ModuleSelector";
import UserModuleSelection from "./UserSelection";
import { setCart } from "../../../../api/CartApi";

const ModuleSelectionStep: React.FunctionComponent = () => {
  const {
    setValues,
    handleNextStep,
    availableExamSessions,
    referenceModules,
    data: { modulesSelection: initialModulesSelection },
  } = useSignUpContext();
  const [modulesSelection, setModuleSelection] = React.useState<ModuleSelectionViewModel[]>(initialModulesSelection);
  const [isCartSubmitting, setIsCartSubmitting] = React.useState(false);
  const { data } = useSignUpContext();

  const onSubmit = async (): Promise<void> => {
    if (modulesSelection.length) {
      setValues({ modulesSelection });
      handleNextStep();
    }
  };

  const allAvailableCourses = availableExamSessions.reduce((courses, currentExamSession) => {
    currentExamSession.courses.forEach((course) => {
      if (courses.find((c) => c.id === course.id) === undefined) {
        courses.push(course);
      }
    });
    return courses;
  }, [] as CourseForSignupViewModel[]);

  const handleModuleSelected = (selection: ModuleSelectionViewModel) => {
    if (
      modulesSelection.find(
        (m) =>
          m.courseId === selection.courseId &&
          m.examSessionId === selection.examSessionId &&
          m.moduleId === selection.moduleId
      ) === undefined
    ) {
      setModuleSelection([...modulesSelection, selection]);
    }
  };

  const handleModuleRemoved = (selection: ModuleSelectionViewModel) => {
    const modules = modulesSelection.filter(
      (m) =>
        m.courseId !== selection.courseId ||
        m.examSessionId !== selection.examSessionId ||
        m.moduleId !== selection.moduleId
    );
    setModuleSelection(modules);
    setIsCartSubmitting(true);
    setCart({ candidateId: data.candidate.id, modules: modules })
      .then(() => {})
      .finally(() => {
        setIsCartSubmitting(false);
      });
  };

  const hasPaidModules = modulesSelection.find((m) => m.paid) !== undefined;

  return (
    <React.Fragment>
      <Container>
        <Grid container spacing={4}>
          <ModuleSelector
            allAvailableCourses={allAvailableCourses}
            availableExamSessions={availableExamSessions}
            selection={modulesSelection}
            referenceModules={referenceModules}
            onModuleSelected={handleModuleSelected}
          />
          <UserModuleSelection modulesSelection={modulesSelection} onModuleRemoved={handleModuleRemoved} />
        </Grid>
      </Container>
      <ControlButtons
        onNextClick={onSubmit}
        nextDisabled={modulesSelection.length === 0}
        isLoading={isCartSubmitting}
        backDisabled={hasPaidModules}
      />
    </React.Fragment>
  );
};

export default ModuleSelectionStep;
